"use client"

import React from "react"
import clsx from "clsx"
import { Box } from "ui/components/atoms/_atoms"
import { BaseStyles } from "ui/types/base-styles"
import { generateStylesFromProps } from "ui/utils/styles"

import styles from "./RadioSlider.module.css"

const RadioSlider = ({
  name,
  value,
  onChange,
  options,
  $columnBreakpoint,
  $column,
  $activeColor = "white",
  $activeBackground = "primary",
  $boxShadow = true,
  className = "",
  style = {},
  ...rest
}: BaseStyles & {
  name: string
  value: string
  onChange: (e: { name: string; value: string }) => void
  options: string[][]
  $column?: boolean
  $activeColor?: string
  $activeBackground?: string
  $columnBreakpoint?: number
  $boxShadow?: boolean
  className?: string
  style?: React.CSSProperties
}) => {
  const generatedStyles = generateStylesFromProps(rest)
  const activeIndex = options.findIndex(el => el[1] === value)

  const wrapperClasses = clsx(
    styles.wrapper,
    {
      [styles.boxShadow]: $boxShadow,
    },
    className,
  )

  const contentClasses = clsx(styles.content, {
    [styles.column]: $column,
  })

  const wrapperStyles = {
    ...generatedStyles,
    ...style,
  }

  const backgroundStyles = {
    "--length": options.length,
    "backgroundColor": $activeBackground.includes("var(--")
      ? $activeBackground
      : `var(--color-${$activeBackground})`,
  } as React.CSSProperties

  return (
    <div className={wrapperClasses} style={wrapperStyles}>
      <div className={contentClasses}>
        {value && value !== "" && (
          <div className={styles.background} style={backgroundStyles} data-position={activeIndex} />
        )}
        {options.map(el => {
          const optionValue = el[1]
          const text = el[0]
          const isActive = value === optionValue

          const optionClasses = clsx(styles.option, {
            [styles.active]: isActive,
          })

          const optionStyles = {
            color: isActive
              ? $activeColor.includes("var(--")
                ? $activeColor
                : `var(--color-${$activeColor})`
              : undefined,
          }

          return (
            <button
              key={optionValue}
              type="button"
              className={optionClasses}
              style={optionStyles}
              onClick={() =>
                onChange({
                  name,
                  value: optionValue,
                })
              }
            >
              {text}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default RadioSlider
